module.exports = __webpack_public_path__ + "img/roof-pitched.974b77d5.svg";